import { render, staticRenderFns } from "./TreatmentModal.vue?vue&type=template&id=959bfe26&scoped=true"
import script from "./TreatmentModal.vue?vue&type=script&lang=js"
export * from "./TreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./TreatmentModal.vue?vue&type=style&index=0&id=959bfe26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959bfe26",
  null
  
)

export default component.exports